import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Steps } from "antd";
import IntroStep from "./IntroStep";
import PaymentDetailsStep from "./PaymentDetailsStep";
import UpgradeCompleteStep from "./UpgradeCompleteStep";
import RequireTenantSelection from "../../../components/RequireTenantSelection";
import { selectedTenantSelector } from "../../../../../store/slice/auth";
import { useAppSelector } from "../../../../../store";
const UpgradeToContractor = () => {
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const [currentStepIdx, setCurrentStepIdx] = useState(0);
    const nextStep = () => {
        setCurrentStepIdx(currentStepIdx + 1);
    };
    const onNavigationStepChange = (value) => {
        setCurrentStepIdx(value);
    };
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "article-title", children: "Start Accepting Jobs" }), _jsx(RequireTenantSelection, { children: _jsxs("div", { children: [_jsx(Steps, { type: "navigation", current: currentStepIdx, onChange: onNavigationStepChange, items: [
                                    { title: 'Intro', content: 'Introduction', disabled: currentStepIdx > 1 },
                                    { title: 'Enter Details', content: 'Enter payment details and confirm address', disabled: currentStepIdx > 1 },
                                    { title: 'Complete', content: 'You\'re ready to start accepting jobs from the marketplace', disabled: true }
                                ] }), _jsxs("div", { style: { paddingTop: "10px" }, children: [currentStepIdx === 0 &&
                                        _jsx(IntroStep, { onComplete: nextStep }), currentStepIdx === 1 &&
                                        _jsx(PaymentDetailsStep, { tenant: selectedTenant, onComplete: nextStep }), currentStepIdx === 2 &&
                                        _jsx(UpgradeCompleteStep, {})] })] }) })] }) }));
};
export default UpgradeToContractor;
